import Button from '@material-ui/core/Button';

export default function NextCancel({ onNext, onCancel, disableNext, content }) {

    return (
        <>
            <Button onClick={onCancel} variant="contained" style={{ marginLeft: 10 }}>
                Cancel
            </Button>
            <Button onClick={onNext} color="primary" variant="contained" style={{ marginLeft: 10 }} disabled={disableNext}>
                {content != undefined ? content : 'Next'}
            </Button>
        </>
    )
}